import type { AxiosError, AxiosResponse } from "axios";
import { defineStore } from "pinia";
import { ref } from "vue";

import { track } from "shared/boot/analytics";
import { $streemApiV1 } from "shared/boot/api";
import { dateToTimestamp, getCurrentTimestamp } from "shared/helpers/date";

import { useUserStore } from "../user";

export const useAlertsStore = defineStore("alerts", () => {
  const alertCount = ref<number>(0);

  function setAlertCount(count: number): void {
    alertCount.value = count;
  }

  function fetchAlertCount(): Promise<number | AxiosError> {
    const alertsReadAt = useUserStore().currentUser.alerts_read_at;

    return $streemApiV1
      .get("alerts", {
        params: {
          ...(alertsReadAt ? { after: dateToTimestamp(alertsReadAt) } : {}),
          limit: 0,
        },
      })
      .then((response: AxiosResponse) => {
        const count = Number(response.headers["x-total-count"]);
        setAlertCount(count);

        return count;
      })
      .catch((error: AxiosError) => error);
  }

  function clearAlertCount(): Promise<void> {
    track("Read Alert");

    setAlertCount(0);

    return useUserStore().updateUser({
      alerts_read_at: getCurrentTimestamp(),
    });
  }

  return {
    alertCount,

    clearAlertCount,
    fetchAlertCount,
    setAlertCount,
  };
});

export default useAlertsStore;
